import type { Attribute, ProductDraft, UploadedFile } from "@/lib/catalog/types";

export const PRODUCT_IMAGE_MAX_BYTES = 10 * 1024 * 1024;
export const PRODUCT_DOC_MAX_BYTES = 10 * 1024 * 1024;

const DOC_MIME_ALLOW =
  /^application\/(pdf|msword|vnd\.openxmlformats-officedocument\.|vnd\.ms-excel)|^text\/|^image\//i;

export function isAllowedProductDocFile(file: File): boolean {
  if (file.size > PRODUCT_DOC_MAX_BYTES) return false;
  if (file.type && DOC_MIME_ALLOW.test(file.type)) return true;
  return /\.(pdf|doc|docx|xls|xlsx|txt|png|jpe?g|webp)$/i.test(file.name);
}

/** Attribute shapes for `mockUploadFile` — product gallery & documents (not category attributes). */
export const PRODUCT_GALLERY_ATTR: Attribute = {
  id: "_product_img",
  code: "_gallery",
  name: "Product images",
  type: "images",
  accept: "image/*",
};

export const PRODUCT_DOCS_ATTR: Attribute = {
  id: "_product_doc",
  code: "_documents",
  name: "Product documents",
  type: "files",
  maxFiles: 20,
  accept: ".pdf,.doc,.docx,.xls,.xlsx,image/*",
};

/** Remove non-JSON `File` handles before session/local persistence. */
export function stripLocalFilesFromDraft(d: ProductDraft): ProductDraft {
  return {
    ...d,
    productImages: (d.productImages ?? []).map(({ localFile: _f, ...rest }) => ({ ...rest })),
    productDocuments: (d.productDocuments ?? []).map(({ localFile: _f, ...rest }) => ({ ...rest })),
  };
}
